import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M9.375 17.063c0 .309-.253.562-.562.562a.564.564 0 0 1-.563-.562V9.75c0-.31.253-.562.563-.562s.562.253.562.562zm2.813 0c0 .309-.254.562-.563.562a.564.564 0 0 1-.562-.562V9.75c0-.31.253-.562.562-.562s.563.253.563.562zm2.812 0c0 .309-.253.562-.562.562a.564.564 0 0 1-.563-.562V9.75c0-.31.253-.562.563-.562S15 9.44 15 9.75zm-.088-13.186 1.29 1.936h2.454a.843.843 0 1 1 0 1.687h-.281v10.688A2.81 2.81 0 0 1 15.563 21H7.687a2.81 2.81 0 0 1-2.812-2.812V7.5h-.281a.843.843 0 1 1 0-1.687h2.454l1.29-1.936A1.97 1.97 0 0 1 9.976 3h3.298a1.97 1.97 0 0 1 1.638.877M9.076 5.813h5.098l-.668-1a.28.28 0 0 0-.232-.125H9.976c-.091 0-.21.047-.232.125zM6.562 18.188c0 .622.504 1.125 1.125 1.125h7.876c.622 0 1.124-.503 1.124-1.125V7.5H6.563z"
    }, null, -1)
  ]))]))
}
export default { render: render }